import type { JobModuleCreateButtonProps } from "./job-module-create-button.type";

import { CaretRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useJobModuleCreateButton } from "./job-module-create-button.hook";

const JobModuleCreateButton = ({
  module,
  subjectType,
  subjectIds,
  loading,
}: JobModuleCreateButtonProps) => {
  const { t } = useTranslation();

  const { triggerModule, isPending } = useJobModuleCreateButton({
    module,
    subjectType,
    subjectIds,
  });

  return (
    <Button
      icon={<CaretRightOutlined />}
      onClick={triggerModule}
      loading={loading || isPending}
    >
      {t("jobModule:launchBtn")}
    </Button>
  );
};

export default JobModuleCreateButton;
